import { Trigger } from '@radix-ui/react-dialog';

import ChevronDownIcon from '~/icons/chevron-down.svg';
import GlobeIcon from '~/icons/globe.svg';
import { Icon } from '~/shared/components/Icon/Icon';

import styles from './marketSelectorTrigger.module.css';

export const MarketSelectorTrigger = ({ marketName }: { marketName?: string }) => {
	return (
		<Trigger asChild>
			<button className={styles.root}>
				<span className={styles.iconAndName}>
					<Icon size="md">
						<GlobeIcon />
					</Icon>
					{marketName}
				</span>
				<Icon size="md">
					<ChevronDownIcon />
				</Icon>
			</button>
		</Trigger>
	);
};
